import Image from 'next/image'
import Logo from 'src/Resources/Images/logo.png';
import AppStoreBtn from "src/Resources/Images/appstorebtn.png";
import PlayStoreBtn from "src/Resources/Images/playstorebtn.png";
import {DrupalLink} from 'src/Utils';

export function Footer({footer}) {

    
    return (
      <div>
          <div className="ajb-grid-row">

            {/*<RiskWarning />*/}
            <div className="highlight darkblue-500-bg white-text region-footer-highlighted no-print">
                <p className="max-characters-none">
                  The value of your investments can go down as well as up and you may get back less than you originally invested. 
                  We don&#39;t offer advice, so it&#39;s important you understand the <DrupalLink action={`/risks`}>risks</DrupalLink>, if you&#39;re unsure please 
                  consult a suitably qualified financial adviser. Tax treatment depends on your individual circumstances and rules 
                  may change. Past performance is not a guide to future performance and some investments need to be held for the 
                  long term.
                </p>
            </div>

            <footer className="footer c-footer darkblue-0-bg ajb-grid-row padding-top-40 padding-bottom-80 padding-left-20 padding-right-20" role="contentinfo">

                <div className="ajb-col-12 ajb-col-8-breakpoint ajb-grid-row">
                    <div className="footer-logo ajb-col-4 ajb-col-8-breakpoint padding-right-20">
                        <p className="margin-bottom-30">
                            <a className="hide-sm" href="#">
                            <Image src={Logo} alt="AJ Bell Youinvest" className="image" width={120} height={38} />
                            </a>
                        </p>
                        <p>
                            <a className="inline-block margin-right-10" href="https://apps.apple.com/gb/app/aj-bell-youinvest/id557882383" alt="Apple app store">
                                <Image src={AppStoreBtn} alt="Apple app store" className="image" width={100} height={34} />
                            </a>
                            <a className="inline-block" href="https://play.google.com/store/apps/details?id=com.apadmi.AJBell&amp;hl=en_GB" alt="Google play store">
                                <Image src={PlayStoreBtn} alt="Google play store" className="image" width={100} height={34} />
                            </a>
                        </p>
                        {/* <div className="ajb-grid-row margin-bottom-40 margin-bottom-10-sm margin-top-30-sm">
                                    <div className="trustpilot-widget" style={{width:'100%', height:'150px'}} data-locale="en-GB" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="5cc5ca2dc826560001cf6396" data-style-height="150px" data-style-width="100%" data-theme="light">
                                        <a href="https://uk.trustpilot.com/review/youinvest.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                                    </div>
                                </div> */}
                    </div>

                    {footer.map((rows) => {
                        return rows.below.map((sub, index) => {
                            return (<div key={index} className="ajb-col-2 ajb-col-8-breakpoint margin-bottom-40 margin-bottom-20-sm">
                                <ul>
                                    <li><span className="subheader red-500-text ">{sub.link.link_title}</span></li>
                                    {sub.below.map((link, linkIndex) => {
                                        let linkClass = `link-arrow ` + (link.link.link_title === 'Web chat' ? 'olark-trigger' : '');
                                        return <li key={linkIndex}><a className={linkClass} href={link.link.link_path}>{link.link.link_title}</a></li>
                                    })}
                                </ul>
                            </div>)
                        });
                    })}

                </div>

                <div className="ajb-col-12 ajb-col-8-breakpoint ajb-grid-row clearfix margin-top-10-sm">
                    <hr className="grey-100-bg" />
                </div>            


                <div className="ajb-col-10 ajb-col-8-breakpoint padding-top-20">
                    <p className="h7 margin-bottom-0">
                        <span className="red-500-text">Important information: </span>
                        <DrupalLink action={`/accessibility`} className="margin-right-10">Accessibility</DrupalLink>
                        <DrupalLink action={`/cookies`} className="margin-right-10">Cookies</DrupalLink>
                        <DrupalLink action={`/privacy-policy`} className="margin-right-10">Privacy policy</DrupalLink>
                        <DrupalLink action={`/disclosures`} className="margin-right-10">Disclosures</DrupalLink>
                        <DrupalLink action={`/risks`} className="margin-right-10">Risk warning</DrupalLink>
                        <DrupalLink action={`/terms-use-website`} className="margin-right-10">Website use</DrupalLink>
                        <DrupalLink action={`/terms-and-conditions`} className="margin-right-10">Terms &amp; Conditions</DrupalLink>
                        <DrupalLink action={`/sites/ajbell.co.uk/files/AJB_Anti-slavery_statement.pdf`} className="margin-right-10">Anti-slavery statement</DrupalLink>
                        <br></br><br></br>Authorised and regulated by the Financial Conduct Authority.<br></br>AJ Bell registered office: AJ Bell, 4 Exchange Quay, Salford Quays, Manchester, M5 3EE.
                    </p>
                    
                    
                </div>
                <div className="ajb-col-2 ajb-col-8-breakpoint padding-top-20">
                    <p className="list-group">
                        <a href="https://www.youinvest.co.uk"><span className="hide">AJ Bell Youinvest</span></a>
                        <a target="_blank" href="https://www.youtube.com/user/AJBellYouinvest" className="list-group-item padding-top-10 padding-bottom-10 padding-right-5 padding-left-0" rel="noreferrer"><i className="fab fa-youtube fa-lg fa-fw" aria-hidden="true"></i></a>
                        <a target="_blank" href="https://twitter.com/ajbell" className="list-group-item padding-top-10 padding-bottom-10 padding-right-5 padding-left-0" rel="noreferrer"><i className="fab fa-twitter fa-lg fa-fw" aria-hidden="true"></i></a>
                        <a target="_blank" href="https://www.linkedin.com/company/a-j-bell" className="list-group-item padding-top-10 padding-bottom-10 padding-right-5 padding-left-0" rel="noreferrer"><i className="fab fa-linkedin fa-lg fa-fw" aria-hidden="true"></i></a>
                        <a target="_blank" href="https://www.facebook.com/AJBell" className="list-group-item padding-top-10 padding-bottom-10 padding-right-5 padding-left-5" rel="noreferrer"><i className="fab fa-facebook-square fa-lg fa-fw" aria-hidden="true"></i></a>
                    </p>
                </div>


            </footer>

          </div>
      </div>
    )
}